import { createSelector } from "reselect";

import { getLoadedShipment } from "./getLoadedShipment";
import { getNonEmptyShipmentItems } from "inbounds/store/util/getNonEmptyShipmentItems";

export const selectLoadedShipmentItems = createSelector(getLoadedShipment, getNonEmptyShipmentItems);
